import http from '@/http/index.js' //axios 请求引入
const httpUrl = process.env.VUE_APP_DOMAIN;
const baseApi = process.env.VUE_APP_BASE_API;
const api = {
	// 文章列表
	artlist(param) {
		return http.get("/api/art/list", param);
	},
	// 文章详情
	artinfo(param) {
		return http.get("/api/art/info", param);
	},
	// 证书列表
	certlist(param) {
		return http.get("/api/cert/list", param);
	},
	// 会议列表
	meetinglist(param) {
		return http.get("/api/meeting/list", param);
	},
	// 会议详情
	meetingdetail(param) {
		return http.get("/api/meeting/detail/" + param.meetingCode, param);
	},
	// 视频详情
	meetingvideo(param) {
		return http.get("/api/meeting/video/" + param.videoCode, param);
	},
	// 联系我们
	feedbackreceive(param) {
		return http.post("/api/feedback/receive " , param);
	},
};



export default {
	...api,
}